module.exports = __webpack_public_path__ + "static/media/video-issue-point-ten.73dc88e0.png";